var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    width: 17,
    height: 17,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_1380",
    transform: "scale(0.05)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_1380",
    width: 20,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAsRJREFUOE+tlEtoVVcUhv+1E44SVHyimKADRRQcaEt1Ik5EFB3oQHyhGL1n72BSWidVqKBHIjpRfGCIN+vcEAyCEhVR0NZZERFUpIWK+CgiRKE+MOCNhB5zftnh3nC5pnoG7uFZ//rOv9daewm+8ZFqXmNj4/ggCBamaTrOGPNZ3OvTNGVNTc07kvc6Ojo+VDKGE5xzdSSPAtgBIMhovEjySENDQ2sURanPGQJGUWR6e3tviMgyAL+LyAUAb74CnUpyC4AlAE6r6s5hoHNuM8mzAI6o6i8Z3ElTU9P3dXV1D4rFYh7AVgCLVPXukENrrXe0emBgYHJ3d3d/NbClpWVSf3//YFdXV5+PhWG4RkQukzwZBMHhJElelMzsKQPvARitqvMrYWEYbheRvQBmlb7/RfJXY8wjkjGAY6p6xVr7HMBdVV1XBv7pE1R1QRkYhuF+EYkAePElkjUishHAFADbVLW7rLXWPgXwt6quHRHonJtL8gGAWyKysjwazrnJJG8CmJ4kycxyCbIA95I8mKbp4kKhcKeyDNba9QDOA9ikqudKPfiyQ2vtcQA/19bWTmxvb39XCczlcguNMfcB7FLVE5mAzrmfSHrxKlW9XtWoFhE5RXJ1HMfXMgHDMJwqIv+IyL+Dg4MrCoWCv5Ifrx8A/AbgfV9f35yenp7/MgFLIl8rP+wkeVtERgHwwKIxZmU+n7/9pS77wo9V1XmV13POfQdgN8nFABKSfwA4FMfxs6pG+cG+parry2NzxnctCIJpbW1tbzM8vWFJLpebbYx5QrI1juN9Q8AwDJeLyA0A5+rr67dGUfQxC7S5uXlMkiRXASwlOT+O44eV6ytP0gF4DOAiyVf/B/V7kmQDgA0A6klGcRwfGN42pUSx1v7oawbAi7OcJwBaK5/hiBvZOTdDRCakaTpi3BjDJEled3Z2vqz+6ydEom4k30rocQAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInstagram);
export default __webpack_public_path__ + "static/media/footer_instagram.05bc53458c033785f8895a950cd09b0d.svg";
export { ForwardRef as ReactComponent };